/** Review row may have voided_at (timestamp) or is_voided (boolean) depending on backend. */
export interface VoidableReview {
  voided_at?: string | null;
  is_voided?: boolean | null;
}

export function isReviewVoided(review: VoidableReview): boolean {
  if (review.is_voided === true) return true;
  return review.voided_at != null && review.voided_at !== "";
}

export function pickFirstNonVoidedReviewId<T extends VoidableReview & { id: string }>(
  reviews: readonly T[],
): string | null {
  return reviews.find((review) => !isReviewVoided(review))?.id ?? null;
}
